<app-spinner [loading]="loading$ | async" size="full"></app-spinner>

<div class="container min-vw-94 ppl pt-4">
  <div class="columns is-centered">
    <div class="column is-3">
      <div class="pb-3">
        <a class="is-link weight-medium is-5" (click)="backToItinerary()">
          <em class="mdi mdi-arrow-left mdi-18px" aria-hidden="true"></em>
          &nbsp;{{ 'cancellation-info.back-itinerary' | translate }}
        </a>
      </div>

      <app-tabs [tabs]="typeTabs">
        <div tab-content>
          <app-passengers
            [passengers]="selectedPassengers$ | async"
            [enabledCheckboxes]="false"
            [showTitle]="false"
          >
          </app-passengers>
        </div>
      </app-tabs>
    </div>

    <div class="column main-container">
      <app-re-route-main-container
        [pnrInfo]="pnrInfo"
        [selectedPassengers]="selectedPassengersSplitQuote"
        [splitIsNecesary]="splitIsNecesary"
        [reRouteQuoteRequest]="reRouteQuoteRequest"
        [isError]="isError$ | async"
        (backButton)="backToItinerary()"
      ></app-re-route-main-container>
    </div>
  </div>
</div>
